type WindowedPeriod = {
	startDate: Date;
	endDate: Date;
};

// Must match the periods `@offstreetparking/invoices` raises deductions for — comparing instants, not
// calendar dates, so a period ending one millisecond before the window opens stays out of it.
export const selectPeriodsInCollectionWindow = <TPeriod extends WindowedPeriod>({
	payPeriods,
	collectionStartDate,
	collectionEndDate,
}: {
	payPeriods: TPeriod[];
	collectionStartDate?: Date | null;
	collectionEndDate?: Date | null;
}): TPeriod[] =>
	payPeriods
		.filter(
			(period) =>
				(!collectionStartDate || period.endDate >= collectionStartDate) &&
				(!collectionEndDate || period.startDate <= collectionEndDate),
		)
		.sort((a, b) => a.startDate.getTime() - b.startDate.getTime());

type DeductedPeriod = {
	startDate: Date;
};

export const isPeriodDeducted = ({
	period,
	permitStart,
	permitEnd,
}: {
	period: DeductedPeriod;
	permitStart: Date;
	permitEnd?: Date | null;
}): boolean => period.startDate >= permitStart && (!permitEnd || period.startDate < permitEnd);

export const selectDeductedPeriods = <TPeriod extends DeductedPeriod>({
	payPeriods,
	permitStart,
	permitEnd,
}: {
	payPeriods: TPeriod[];
	permitStart: Date;
	permitEnd?: Date | null;
}): TPeriod[] => payPeriods.filter((period) => isPeriodDeducted({ period, permitStart, permitEnd }));
